import React from 'react';
import { Badge } from 'reactstrap';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const BaseBadge = ({ className, children, ...rest }) => {
  const mergedClassName = `${className} ${styles.base}`;
  return (
    <Badge className={mergedClassName} {...rest}>{children}</Badge>
  );
};

BaseBadge.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

BaseBadge.defaultProps = {
  type: '',
  className: '',
};

export default BaseBadge;
